/*
- BENODIGDE JAVASCRIPT:
  /js/jquery/jquery.js
  /js/jquery/plugins/autocomplete/jquery.autocomplete.js
- Om de desbetreffende input moet een div staan met gespecificeerde class daarnaast moet het id gezet zijn.
  Dit id word gebruikt bij de formulier output in de vorm van <tag>_<index>, waarbij <index> van 0 tot het
  aantal tags gaat en dit verschillende tags zijn.
*/


/*
	VOORBEELD STIJL:
	.tags {
		border-color: #EEEEEE;
		border-style: inset;
		border-width: 2px;
		padding: 3px 3px 0 3px;
		white-space: nowrap;
		width: 400px;
	}
	.tags input {
		border: none;
		margin-bottom: 3px;
	}
	.tags div {
		display: inline-block;
		margin-bottom: 3px;
	}
	.tags div span.tag_item {
		background-color: rgb(199,209,255);
		padding: 0px 3px;
		margin: 0 0 3px 0;
		border-radius: 15px;
		border: 1px solid #666666;
		background-image: linear-gradient(top, rgb(199,209,255) 1%, rgb(0,85,255) 99%);
		background-image: -o-linear-gradient(top, rgb(199,209,255) 1%, rgb(0,85,255) 99%);
		background-image: -moz-linear-gradient(top, rgb(199,209,255) 1%, rgb(0,85,255) 99%);
		background-image: -webkit-linear-gradient(top, rgb(199,209,255) 1%, rgb(0,85,255) 99%);
		background-image: -ms-linear-gradient(top, rgb(199,209,255) 1%, rgb(0,85,255) 99%);
		background-image: -webkit-gradient(linear,top,bottom,color-stop(0.01, rgb(199,209,255)),color-stop(0.99, rgb(0,85,255)));
	}
	.tags span.remove {
		padding: 3px;
		padding-left: 1px;
		padding-right: 5px;
		cursor: pointer;
		border-radius: 15px;
		color: #666666;
		font-size: 0.8em;
		top: -0.5em;
		position: relative;
	}
	.tags span.remove:hover {
		color: #000000;
		font-weight: bold;
		padding-right: 4px;
	}
	.acResults ul {
		list-style-type: none;
		background-color: #F6F6F6;
		border: 1px solid #666666;
		margin: 0;
	}
	.acResults ul li {
		padding: 0px 5px;
		margin: 0;
		font-size: 14px;
	}
	.acSelect {
		background-color: #BBBBBB;
	}
	.acMatch {
		font-size: 14px;
	}
	
	
	voorbeeld aanroepen:
	$('.tags').tagModule({'scriptLocation':'/autocomplete.php',
	                       'displayFunc' : displayTag,
	                       'removeTagHook' : removeTag});
*/
(function($) {
	
	var keyCode = {
		ENTER : 13,
		BACKSPACE : 8
	};
	
	$.fn.tagModule = function(options) {
		var self = this;
		
		var defaults = {
			'scriptLocation': 'autocomplete.php',//hier staat het php script waaruit de tags worden gehaald
			                            //in dit script zijn twee waarden gezet, namelijk:
			                            // - $_GET['id'] dit is het id van de div waarin de tag input staat
			                            // - $_GET['tag'] dit is het deel van de tag wat al getyped is
			                            //uit dit bestand moet een lijst komen van tags gescheiden door een "\n"
			'displayFunc': displayTag,  //Deze functie word uitgevoerd bij het genereren van een tag. Het is aan
			                            //te raden om van het buitenste blokje een div te maken
			                            // IN:  tag    - dit is een string met de tag die weergegeven wordt
			                            //      id     - id van de div waar deze tag wordt aangemaakt
			                            // UIT: string - deze string word voor het inputveld neergezet en is
			                            //               te zien als een apart blokje
			'removeTagHook': null,       //Deze functie word uitgevoerd als een tag verwijderd wordt, ofwel als
			                            //dit via de backspace key gedaan wordt ofwel via het kruisje
			                            // IN: tag    - dit is een string met de tag die is vergehaald
			                            //     id     - id van de div waar deze remove vandaan kwam
			'spanTagClass': 'tag_item', //dit moet uniek zijn
			
			'setWidth' : true,          //dit zorgt voor de width

			'id' : null,                // this is used for the name of the hidden input elements in
			                            // reFormat(). if null, the default is the id of the element
			                            // on which this module is activated.
			
			autocompleteSettings: {}    // overwrite default autocomplete settings
		};
		
		var opts = $.extend(true, {}, defaults, options);
		return this.each(function() {
			new Plugin(this, opts);
		});
	};
	
	function Plugin(element, options) {
		
		var self = this;
		var id = (options.id !== null) ? options.id : $('> input', element).parent().attr('id');
		
		this.element = element;
		this.options = options;
		this.id      = id;
		
		var width = $(element).width();
		width -= ($('> input', element).outerWidth(true) - $('> input', element).width());
		
		$('> input', element).attr('autocomplete', 'off');
		
		if (options.setWidth === true) {
			$('> input', element).css('width', width);
		}
		
		var autocompleteDefaults = {
			url: options.scriptLocation,
			extraParams: {
				id: id,
				output: "ajax",
			},
			maxItemsToShow: 15,
			matchSubset: 0,
			delimiterKeyCode: -1, //event niet uitvoeren
			queryParamName: 'tag',
			disableQuotes: true
		};
		
		var autocompleteOptions = $.extend(true, {}, autocompleteDefaults, options.autocompleteSettings);
		
		auto_lastValue = {};
		
		$('> input', element).autocomplete(autocompleteOptions);
		
		// Prevent multiple delete actions when holding backspace.
		var backspaceDown = false;
		$('> input', element).keyup(function(e) {
			if (e.which == keyCode.BACKSPACE) {
				backspaceDown = false;
			}
		});
		
		$('> input', element).keydown(function(e) {
			//als het textveld leeg is verwijder dan de vorige tag
			if (e.which == keyCode.BACKSPACE && $(this).val() == '' && !backspaceDown) {
				e.preventDefault();
				
				var tag = self.lastTag();
				if (tag) {
					self.removeTag(tag);
				}
				
				backspaceDown = true;
			}
			//als er text in het input veld staat maak hier dan een nieuwe tag van
			if (e.which == keyCode.ENTER && $(this).val() != '') {
				$(this).val($(this).val()+',');
				self.reFormat();
				e.preventDefault();
			}
		});
	
		//kijkt of er nieuwe tags gemaakt moeten worden
		var changeEvent = function() {
			if ($(this).val().indexOf(',') != -1) {
				var string = $(this).val();
				var splitted = string.split(',');
				var length = splitted.length;
				for (var i = 0; i < length; i++) {
					self.addTag(splitted[i], false);
				}
				$(this).val('');
				self.reFormat();
			}
		};
	
		$('> input', element).keyup(changeEvent);
		$('> input', element).focusin(changeEvent);
	
		$('> input', element).each(function(){
			$(this).val($(this).val() + ',');
		});
		
		$('> input', element).each(function () {
			if ($(this).val().indexOf(',') != -1) {
				var string = $(this).val();
				var splitted = string.split(',');
				var length = splitted.length;
				for (var i = 0; i < length; i++) {
					self.addTag(splitted[i], true);
				}
				$(this).val('');
				self.reFormat();
			}
		});
		
	}
	
	
	Plugin.prototype.reFormat = function() {
		
		var id = this.id;
		
		$(this.element).children('div').each(function() {
			$(this).children('input').eq(0).attr('name', id + '[]');
		});
	};
	
	
	// Add a single tag
	// IN: value       - the name of the tag (trimming whitespate)
	//     duringInit  - if this is called during initialisation of the plugin. Default: FALSE
	//UIT: FALSE if tag was not added.
	Plugin.prototype.addTag = function(value, duringInit) {
		
		var self    = this;
		var element = this.element;
		var options = this.options;
		var id      = this.id;
		
		value = $.trim(value);
		duringInit = typeof duringInit != 'undefined' ? duringInit : false;
		
		if (value === '') {
			return false;
		}
		
		var $tag = options.displayFunc(value, id, options.spanTagClass, !duringInit);
		$('> input', element).before($tag);
		
		$tag.children('.remove').click(function() {
			self.removeTag($tag);
		});
	};
	
	
	// Remove a tag item by its DOM element
	// IN: tag - the tag DOM element
	//UIT:
	Plugin.prototype.removeTag = function(tag) {
		
		var id      = this.id;
		var options = this.options;
		
		tag.remove();
		this.reFormat();
		
		if (options.removeTagHook !== null) {
			options.removeTagHook(tag.find('.' + options.spanTagClass).html(), id);
		}
		
	};
	
	
	// Returns the element of the last tag.
	// IN:
	//UIT: jquery DOM element
	Plugin.prototype.lastTag = function() {
		return $(this.element).find('div:last');
	};
	
	
	function displayTag(tag, spanTagClass) {
		return $('<div>').append(
		    $('<input>', { type: 'hidden', value: tag }),
		    $('<span>', { 'class': spanTagClass, text: tag }),
		    "<span class='remove'>x</span>"
		);
	}
	
})(jQuery);

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
